import { NgClass } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { SidebarHeaderComponent } from '../../../sidebar/components/sidebar-header/sidebar-header.component';

@Component({
  selector: 'app-header-mobile',
  standalone: true,
  templateUrl: './header-mobile.component.html',
  styleUrls: ['./header-mobile.component.scss'],
  imports: [
    MatButtonModule,
    MatIconModule,
    NgClass
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderMobileComponent extends SidebarHeaderComponent {
}
